import clsx from 'clsx';
import Icon from 'components/Icon';
import {FC} from 'react';

export type BooleanValueProps = {
    className?: string;
    label?: string;
    value: boolean;
};

const BooleanValue: FC<BooleanValueProps> = ({className, label, value}) => (
    <div className={clsx(label && 'flex', className)}>
        <Icon
            className={clsx(label && 'flex-none', 'p-1')}
            icon={value ? 'enabled_checkbox' : 'disabled_checkbox'}
            size="base"
        />
        {label && <div>&nbsp;{label}</div>}
    </div>
);

export default BooleanValue;
